import { render } from "./GeneCard.vue?vue&type=template&id=24588d96&scoped=true"
import script from "./GeneCard.vue?vue&type=script&lang=js"
export * from "./GeneCard.vue?vue&type=script&lang=js"

import "./GeneCard.vue?vue&type=style&index=0&id=24588d96&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-24588d96"]])

export default __exports__